var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfiliaccesso = function SvgProfiliaccesso(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M50,.5h0A49.5,49.5,0,0,1,99.5,50h0A49.5,49.5,0,0,1,50,99.5h0A49.5,49.5,0,0,1,.5,50h0A49.5,49.5,0,0,1,50,.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pay"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M62.12,24.39,19.45,35.83A3.51,3.51,0,0,0,17,40.14l7,26.25a3.43,3.43,0,0,0,4.22,2.36L30,68.29,24.26,46.88a6.55,6.55,0,0,1,4.66-8h0L66.82,28.71l-.48-1.8A3.48,3.48,0,0,0,62.12,24.39Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M75,54a2.46,2.46,0,0,0-3.28,1.2,1.61,1.61,0,0,1-.17.28,1.54,1.54,0,0,1-2.15.35h0a2.48,2.48,0,0,0-2.82,4.07,2.51,2.51,0,0,0,2.05.36,2.41,2.41,0,0,0,1.61-1.36,1.54,1.54,0,0,1,1-.85,1.46,1.46,0,0,1,1.28.22,2.3,2.3,0,0,0,.4.23A2.48,2.48,0,1,0,75.12,54L75,54Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M72.42,30.41,29.72,41.85a3.47,3.47,0,0,0-2.49,4.22h0l.59,2.19L77.29,35l-.58-2.19a3.47,3.47,0,0,0-4.27-2.42Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1811",
    "data-name": "Rectangle 1811",
    x: 29.55,
    y: 43.93,
    width: 49.51,
    height: 4.95,
    transform: "translate(-10.17 15.64) rotate(-15.01)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M30.46,58.11l3.79,14.16a3.53,3.53,0,0,0,4.3,2.51L81.23,63.34A3.55,3.55,0,0,0,83.71,59L79.92,44.84ZM79.28,58a5.57,5.57,0,0,1-7.09,3.44,5.44,5.44,0,0,1-2.77,1.73,5.57,5.57,0,0,1-2.88-10.76,5.5,5.5,0,0,1,3.26.12A5.57,5.57,0,0,1,79.28,58Z",
    fill: "#fff"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfiliaccesso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profiliaccesso.9d53c901.svg";
export { ForwardRef as ReactComponent };